import React, { useEffect, useState } from 'react';
import { Grid, Typography } from '@material-ui/core';
import "./LoginPage.css";
import sinalSoma from '../../assets/images/logos/sinalSoma2.png';
import LoginForm from './LoginForm';
import useUser, { useAuth, usePasswordReset } from '../../Hooks/UserContext';
import ForgotPasswordModal from './ForgotPasswordModal';
import ConfirmPasswordResetModal from './ConfirmPasswordResetModal';
import { Redirect } from 'react-router-dom';
import { toast } from 'react-toastify';
import useQuery from '../../Hooks/useQuery';

const LoginPage = (props) => {
  const [credentials, setCredentials] = useState({ login: '', senha: '', banco: 'SOMA' });
  const [forgotPassword, setForgotPassword] = useState(false);
  const [confirmReset, setConfirmReset] = useState(false);

  const user = useUser();
  const query = useQuery();

  const { login, retoken } = useAuth();
  const { suggestReset, acceptReset } = usePasswordReset();

  useEffect(() => {
    if (suggestReset.data) {
      setForgotPassword(false);
      setConfirmReset(true);
    }
  }, [suggestReset.data]);

  useEffect(() => {
    if (acceptReset.data) {
      setConfirmReset(false);
      toast.success('Email com senha enviado');
    }
  }, [acceptReset.data]);

  useEffect(() => {
    const retokenDispatch = retoken.dispatch;
    if (query.code) {
      retokenDispatch(query.code);
    }
  }, [query.code, retoken.dispatch]);

  const credentialsHandler = (field, value) => setCredentials({ ...credentials, [field]: value });

  if (user) return (<Redirect to="/" />);

  return (
    <div className="div__background--conteiner" >
      <ForgotPasswordModal
        open={forgotPassword}
        credentials={credentials}
        onChange={credentialsHandler}
        onConfirm={() => suggestReset.dispatch(credentials.login, credentials.banco)}
        onClose={() => suggestReset.status === 'ready' && setForgotPassword(false)}
      />
      <ConfirmPasswordResetModal
        open={confirmReset}
        confirmEmail={suggestReset.data?.email}
        onConfirm={() => acceptReset.dispatch(credentials.login, credentials.banco)}
        onClose={() => { acceptReset.status === 'ready' && setConfirmReset(false); }} />
      <Grid container direction="column" alignItems="center" justify="center" style={{ height: "100%" }} >
        <Grid container direction='column' justify="center" alignItems="center" style={{ margin: "70px 0 0 20%", width: "500px" }}>
          <Grid item >
            <Typography variant="h5" style={{ marginRight: '150px', textAlign: "center", color: "#515151", fontSize: "42px", fontFamily: "flama-basic" }}>
              BEM VINDO AO
            </Typography>
          </Grid>
          <Grid container justify="center" direction="row" alignItems="center" spacing={1} style={{ marginBottom: "25.5px" }}>
            <Grid item>
              <Typography variant="h4" style={{ fontSize: "78px", fontFamily: 'flama-cond' }} >
                SOMAPLACE
              </Typography>
            </Grid>
          </Grid>
          <LoginForm
            credentials={credentials}
            onChange={credentialsHandler}
            onConfirm={login.dispatch}
            onForgotPassword={() => setForgotPassword(true)}
            status={login.status} />
        </Grid>
      </Grid>
    </div>
  );
};


export default LoginPage;
